import { FC, ElementType } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import {
  LayoutGrid,
  FileText,
  FileStack,
  User,
  Settings,
  LogOut,
  ChevronRight,
} from 'lucide-react'
import { useAuth } from '../auth/AuthContext'

interface AccountSidebarItem {
  label: string
  path: string
  icon: ElementType
}

// Rutas del menú de cuenta (ver también ACCOUNT_MENU_ROUTES en ProgressGuard
// — deben mantenerse en sync: cualquier ruta agregada aquí debe agregarse
// también ahí para que sea de navegación libre durante la 1ra solicitud).
const ACCOUNT_SIDEBAR_ITEMS: AccountSidebarItem[] = [
  { label: 'Mis arrendamientos', path: '/mis-arrendamientos', icon: LayoutGrid },
  {
    label: 'Mis cotizaciones',
    path: '/onboarding/pending-proposals',
    icon: FileText,
  },
  { label: 'Mis documentos', path: '/mis-documentos', icon: FileStack },
  { label: 'Mi perfil', path: '/mi-perfil', icon: User },
  { label: 'Configuración', path: '/configuracion', icon: Settings },
]

export const AccountSidebar: FC = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const { logout } = useAuth()

  const handleLogout = () => {
    logout()
    navigate('/login')
  }

  return (
    <aside className="w-72 shrink-0 bg-white rounded-2xl shadow-md p-4 sticky top-24 max-h-[calc(100vh-9rem)] overflow-y-auto">
      <nav className="flex flex-col gap-2">
        {ACCOUNT_SIDEBAR_ITEMS.map(item => {
          const isActive =
            location.pathname === item.path ||
            location.pathname.startsWith(item.path + '/')
          const Icon = item.icon

          return (
            <button
              key={item.path}
              type="button"
              onClick={() => navigate(item.path)}
              className={`flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium text-left transition-colors ${
                isActive
                  ? 'bg-olr-primary/10 text-olr-primary'
                  : 'text-olr-dark hover:bg-olr-grey-1'
              }`}
            >
              <Icon size={18} />
              <span className="flex-1">{item.label}</span>
              {isActive && <ChevronRight size={16} />}
            </button>
          )
        })}
      </nav>

      <div className="mt-4 border-t border-olr-grey-2 pt-4">
        <button
          type="button"
          onClick={handleLogout}
          className="flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium text-olr-body hover:bg-olr-grey-1 w-full text-left"
        >
          <LogOut size={18} />
          <span>Cerrar sesión</span>
        </button>
      </div>
    </aside>
  )
}
